import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import CenterPanel from './center_panel';
import { ProjectWorkspaceProvider } from './provider';
const ProjectsWorkspace = () => {
    return (React.createElement(PermissionChecker, { isRoute: true, requiredAllPermissions: [
            Permissions.VIEW_PROJECTS_WORKSPACE_PAGE,
        ] },
        React.createElement(ProjectWorkspaceProvider, null,
            React.createElement(CenterPanel, null))));
};
export default ProjectsWorkspace;
